function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.813 0.108738C13.696 0.0137291 13.542 -0.0192739 13.392 0.0107288L4.392 2.01091C4.163 2.06192 4 2.26493 4 2.49896V10.4097C3.581 10.1557 3.065 9.99964 2.5 9.99964C1.122 9.99964 0 10.8967 0 11.9998C0 13.1029 1.122 14 2.5 14C3.878 14 5 13.1029 5 11.9998V5.90026L13 4.1221V8.40949C12.581 8.15547 12.065 7.99945 11.5 7.99945C10.121 7.99945 9 8.89654 9 9.99964C9 11.1027 10.121 11.9998 11.5 11.9998C12.879 11.9998 14 11.1027 14 9.99964V0.498773C14 0.346759 13.932 0.203746 13.813 0.108738Z",
  fill: "black"
});

var SvgLesson = function SvgLesson(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLesson, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lesson.37e408b5.svg";
export { ForwardRef as ReactComponent };